import findIndex from 'lodash/findIndex';

export default (state = {}, action = {}) => {
  switch(action.type) {
    case 'FETCH_POSTS':
      if(action.data.length>0){
        return {
          ...state,
          [action.order_id]:action.data
        }
      }
      else{
        return {
          ...state,
          [action.order_id]:[]
        }
      }
    case 'FETCH_POSTS_BATCH':
      return {
        ...state,
        ...action.payload
      }
    case 'EDIT_POST':
      const index = findIndex(
        state[action.payload.post_order_id],
        { post_id: action.payload.post_id }
      );
      if (index >= 0) {
        const newState =  {
          ...state,
          [action.payload.post_order_id]:[
            ...state[action.payload.post_order_id].slice(0, index),
            action.payload,
            ...state[action.payload.post_order_id].slice(index + 1)
          ]
        }
        if (action.payload.update_pmnts_seller === 1) {
          newState[action.payload.post_order_id].forEach(post => {
            if (post.post_link === action.payload.post_id) {
              post.post_seller = action.payload.post_seller;
            }
          });
        }
        if (action.payload.update_costs_srvc === 1) {
          newState[action.payload.post_order_id].forEach(post => {
            if (post.post_link === action.payload.post_id) {
              post.post_srvc_id = action.payload.post_srvc_id;
            }
          });
        }
        if (action.payload.update_srvg_id === 1) {
          newState[action.payload.post_order_id].forEach(post => {
            if (post.post_link === action.payload.post_id) {
              post.post_srvg_id = action.payload.post_srvg_id;
            }
          });
        }
        if (action.payload.post_active === 0) {
          const foundIds = [action.payload.post_id];
          newState[action.payload.post_order_id].forEach(post => {
            if (post.post_link === action.payload.post_id) {
              foundIds.push(post.post_id);
            }
          });
          newState[action.payload.post_order_id].forEach(post => {
            if (foundIds.indexOf(post.post_link) !== -1) {
              post.post_active = 0;
            }
          });
        }
        return newState;
      }
      return state;
    case 'CREATE_POST':
      return {
        ...state,
        [action.payload.post_order_id]:[
          ...state[action.payload.post_order_id],
          action.payload
        ]
      }
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/posts.js